<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    红岭北站<br>
站点介绍<br>
红岭北站位于红岭北路与八卦三路、梅园路十字路口处，7,9号线的换乘站，A出入口周边有深爱大厦、福田医院，B出入口靠近八卦一路美食街，D出入口、G出入口离艺展中心较近，J口北边是深爱公寓，红岭北站装修风格为梅香客韵，呼应和谐主题，整个空间协调统一。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:28	23:08	7号线	3分35秒	5分55秒<br>
太安	06:21	23:48	7号线	3分35秒	5分55秒<br>
前湾	06:33	23:13	9号线	3分50秒	5分55秒<br>
文锦	06:15	23:56	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:27	23:08	7号线	4分钟	5分55秒<br>
太安	06:20	23:48	7号线	4分钟	5分55秒<br>
前湾	06:33	23:13	9号线	4分25秒	5分55秒<br>
文锦	06:13	23:55	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:28	00:08	7号线	4分钟	5分55秒<br>
太安	06:20	00:48	7号线	4分钟	5分55秒<br>
前湾	06:33	00:13	9号线	4分钟	5分55秒<br>
文锦	06:11	00:55	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
八卦四路、福田区八卦岭社区健康服务中心、深爱大厦、深药大厦、万乐大厦、荣生大厦、光纤工业小区<br><br>
B出入口:<br>
八卦三路、众鑫科技大厦<br><br>
D出入口:<br>
梅园路南侧、红岭北路东侧（南）、罗湖区税务局、桃园商业大厦<br><br>
G出入口:<br>
梅园路北侧、梨园路西侧、ADC艺展中心、中国人保（深圳）金融大厦<br><br>
J出入口:<br>
红岭北路东侧（北）<br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 红岭泥岗立交<br>
5路、8路、高峰专线29、23路、85路、M138（原385）、M463路、E25路、222、M105、M193路<br><br>
D出入口:<br>
公交站名： 红岭北地铁站<br>
M138（原385）、E25路、M463路<br><br>
J出入口:<br>
公交站名： 红岭泥岗立交<br>
M138（原385）、5路、8路、高峰专线29（原9路）、23路、57路、69路、M463路、85路、222路、321路、M389、M105、M193<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jiuhaoxian",
          title: "9号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>